import React from "react";
import './HeaderAll.css';
import Header01 from "../../../static/img/Header/Header01.png";
import Header03 from "../../../static/img/Header/Header03.png";
import IconsSiteFxBTC33 from "../../../static/img/SVG/IconsSiteFxBTC33.svg";
import IconsSiteFxBTC34 from "../../../static/img/SVG/IconsSiteFxBTC34.svg";
import IconsSiteFxBTC35 from "../../../static/img/SVG/IconsSiteFxBTC35.svg";
import HeaderAllInvest from "../../../static/img/Header/MainMenu03.png";
import TwitterLogo from "../../../static/img/Header/twitter.svg";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
import CheckLanguage from "../TopMenu/CheckLanguage/CheckLanguage";
import CabinetHeader from "../TopMenu/Cabinet/Cabinet";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";
const PRERENDER_TEXTS = require("../../../../prerender_base.js");

function HeaderAllGatsby(props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(PRERENDER_TEXTS['Header'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['Header'][info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

    return ( <header>
        {/*<script async src="https://my.fxbitcoin.org/mt7.js"/>*/}
        <div className="HeaderAllOut">
        <div className="HeaderAll">
            <div className="HeaderAllLogoMain">
                <ChangeLink lang={props.lang}  to="/"  style={{textDecoration: 'none'}}>
                    <img alt='alt' src={Header01}/>
                </ChangeLink>

            </div>
            <div className="HeaderAllLogoMainSmall">
                <img alt='alt' src={Header03}/>
            </div>
            <div className="HeaderAllLogoTitle">
              <div className="HeaderAllLogoTitleIn">
                <TextSource ArrIndex= 'Header0000'>ПОЛНАЯ АНОНИМНОСТЬ</TextSource>
              </div>
                <div className="HeaderAllLogoTitleInLogo">
                    <a href="https://twitter.com/FXBitcoin4" target='_blank' rel="noopener noreferrer" ><img src={TwitterLogo}  alt='Ifyoudontseeimages' height='36px'/></a>
                </div>

            </div>
            <CheckLanguage lang={props.lang}  index={props.index} />


            <div className="HeaderAllThreeButtonsElementOne HeaderAllThreeButtonsElementImg"> <img alt='alt' src={IconsSiteFxBTC33} height="38" width="25"/></div>
            <div className="HeaderAllThreeButtonsElementOneTitle HeaderAllThreeButtonsElementTitle">
                <ChangeLink lang={props.lang}  to='/trader/open/'  style={{textDecoration: 'none'}}><TextSource ArrIndex= 'Header0005'>Открыть</TextSource>
                <div  className="ToDel"><TextSource ArrIndex= 'Header0010'>счет</TextSource></div></ChangeLink>  </div>

            <div className="HeaderAllThreeButtonsElementTwo HeaderAllThreeButtonsElementImg"> <img alt='alt' src={IconsSiteFxBTC34} height="38" width="38"/></div>
            <div className="HeaderAllThreeButtonsElementTwoTitle HeaderAllThreeButtonsElementTitle">
                <ChangeLink lang={props.lang}  to='/trader/deposit/'  style={{textDecoration: 'none'}}> <TextSource ArrIndex= 'Header0015'>Пополнить</TextSource>
                    <div  className="ToDel"><TextSource ArrIndex= 'Header0020'>баланс</TextSource></div> </ChangeLink></div>

            <div className="HeaderAllThreeButtonsElementThree HeaderAllThreeButtonsElementImg"> <img alt='alt' src={IconsSiteFxBTC35} height="40" width="32"/></div>
            <div className="HeaderAllThreeButtonsElementThreeTitle HeaderAllThreeButtonsElementTitle">
                <ChangeLink lang={props.lang}  to='/trader/withdrawal/'  style={{textDecoration: 'none'}}> <TextSource ArrIndex= 'Header0025'>Вывести</TextSource>
                    <div  className="ToDel"> <TextSource ArrIndex= 'Header0030'>средства</TextSource></div></ChangeLink></div>

            <div className="HeaderAllConsEnter">
                <CabinetHeader lang={props.lang} />
            </div>
            <div className="HeaderAllInvest">
                <img alt='Ifyoudontseeimages' src={HeaderAllInvest} height="26px"/>
                <div className="BannerTextInfo">
                    <ChangeLink lang={props.lang} to={`/Invest`}>
                        <div className="BannerTextInfoAnch"><TextSource ArrIndex= 'Header0040'>Получи 100 $ на счет!</TextSource></div>
                    </ChangeLink>
                    <div className="BannerTextInfoText"><TextSource ArrIndex= 'Header0045'>Даём деньги в управление всем</TextSource></div>
                </div>
            </div>
        </div>
        </div>
    </header>
)}

export default HeaderAllGatsby